/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { getComponentZoneLayout } from "cms/components/components/component";
import { HeadingComponentDisplay } from "cms/components/components/heading/display";
import { HeadingComponentEditor } from "cms/components/components/heading/edit";

const HeadingComponent = (props) => {
    
    const { ...everything } = props;
    const zoneProps = {
        ...everything,
        displayComponent: <HeadingComponentDisplay />,
        editComponent: <HeadingComponentEditor />,
    };
    return getComponentZoneLayout(zoneProps);
};

HeadingComponent.displayName = "HeadingComponent";
export { HeadingComponent };
